module.exports = __webpack_public_path__ + "static/img/celoscope-detail-3.e8d07b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-3.jpg
// module id = gpeV
// module chunks = 52